import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const HomePage = () => {
  return (
    <MicroFrontEnd name={'HomePage'} src={apiConfig.microFrontEnds.HomePage} />
  )
}
export default HomePage
